<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" :style="{ height:`${height}px`, 'min-height': `calc(${contentHeight}px + 10vh + 320px)` }">
      <button type="button" class="btn-close" @click="$emit('close')" :aria-label="$t('error.close')">
        <span class="fa fa-times fa-3x"></span><br>
        <h3>{{ $t('error.close') }}</h3>
      </button>
      <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" ref="modal-content">
        <header class="modal-header" id="modalTitle">
          <slot name="header"></slot>
        </header>

        <section class="modal-body" id="modalDescription">
          <slot name="body"></slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: ['height'],
  data() {
    return {
      contentHeight: 0,
    };
  },
  destroyed() {
    document.body.style.minHeight = 'auto';
  },
  mounted() {
    if (this.$refs['modal-content']) {
      const rects = this.$refs['modal-content'].getClientRects();
      this.contentHeight = rects[0].height;
      document.body.style.minHeight = `calc(${this.contentHeight}px + 10vh + 320px)`;
    }
  },
};
</script>

<style>
  .modal-backdrop {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(28,30,31,0.95);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 10vh;
  }

  .modal {
    background: #FFFFFF;
    width: 66.66vw;
    min-height: 50vh;
    padding: 30px;
    margin-right: 75px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .modal-header,
  .modal-footer {
    display: flex;
    flex-grow: 0;
  }

  .modal-header {
    position: relative;
    justify-content: space-between;
  }

  .modal-footer {
    margin: 3em 0 2em 0;
    flex-direction: row;
  }

  .modal-body {
    flex-grow: 1;
  }

  .btn-close {
    position: absolute;
    top: 10vh;
    right: calc(16.665vw - 35px);
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #FFFFFF;
  }

  .btn-close h3 {
    font-size: 10px;
    font-weight: bold;
    color: #FFFFFF;
    text-transform: uppercase;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>
